<section
  *ngIf="data"
  class="faq-image-panel"
  [ngClass]="{ 'not-ready': !ready, 'full-width': !isPanelHasImage }"
>
  <div class="faq-image-panel__content">
    <h2 *ngIf="data.title?.value" class="faq-image-panel__title" #titleEl>
      {{ data.title.value }}
    </h2>
    <div
      *ngIf="data.description?.value"
      [innerHTML]="data.description.value | safe"
      class="faq-image-panel__description"
      #descriptionEl
    ></div>

    <div class="faq-image-panel__wrapper">
      <div class="faq-image-panel__faq">
        <div *ngIf="data.items?.value" class="faq-image-panel__items">
          <app-faq-image-panel-item
            *ngFor="let item of data.items.value"
            [item]="item"
            id="{{ item.anchor?.value }}"
          ></app-faq-image-panel-item>
        </div>
      </div>

      <div *ngIf="isPanelHasImage" class="faq-image-panel__image">
        <img [src]="data.image.value.src"
      [alt]="data.image.value.alt ? data.image.value.alt : ''"
      [ngStyle]="{aspectRatio: data.image?.value?.width / data.image?.value?.height}" />
      </div>
    </div>
  </div>
</section>
